import React from "react";
import "./style.css";

function Footer() {
  return (
    <footer className="footer">
      <span>Employee Directory 2021</span>
    </footer>
  );
}

export default Footer;
